import React, { Component } from 'react';

import capitalize from 'capitalize';

import * as ByesignHelper from 'components/byesign/ByesignHelper';
import * as ColorHelper from 'helpers/ColorHelper';

class DocumentStatus extends Component {
  friendlyStatus = status => {
    return capitalize(status.toLowerCase().replace('_', ' '));
  };

  render() {
    let color = ColorHelper.colors.YELLOW;
    let status = this.props.status;
    if (status === ByesignHelper.status.DOCUMENT_CANCELLED) {
      color = ColorHelper.colors.RED;
    } else if (
      status === ByesignHelper.status.INVALID_DOCUMENT ||
      status === ByesignHelper.status.UNKNOWN
    ) {
      color = ColorHelper.colors.GRAY;
    } else if (status === ByesignHelper.status.DOCUMENT_COMPLETED) {
      color = ColorHelper.colors.GREEN;
    }

    return (
      <span>
        <span style={{ color }}>&#x25cf;</span> {this.friendlyStatus(status)}
      </span>
    );
  }
}

export default DocumentStatus;
